export default "__VITE_ASSET___ww38SH7__"